'use client';

import Link from 'next/link';
import styles from './bookmarkCard.module.scss';

export type BookmarkCardProps = {
  title?: string;
  description?: string;
  buttonText?: string;
};

export function BookmarkCard({
  title = 'Bookmark your favourite breeds for later',
  description,
  buttonText = 'Save'
}: BookmarkCardProps) {
  return (
    <div className={styles.card}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {description && <p className={styles.description}>{description}</p>}
      <div className={styles.buttonContainer}>
        <Link href="/login" className={styles.button}>
          {buttonText}
        </Link>
      </div>
    </div>
  );
}
